// extracted by css-extract-rspack-plugin
export default {"cls1":"index-cls1_wps","cls2":"index-cls2_JmX index-cls1_wps"};